// const BASE_URL = "http://localhost:3001";
const BASE_URL = "https://api.bestchoicerental.trangotechdevs.com/";
// APIs design from Shaheer
const API_URL = BASE_URL + "api/admin/";

const INITIAL_TOKEN = "d24a8f54-1db8-4f63-9a3e-bb6a4beea1b2";

export { API_URL, BASE_URL, INITIAL_TOKEN };
